export default "assets/images/4cb1b7619751e3f50438544cc96f791f.png";